import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from '../style.module.less'

@observer
export default class extends Component {
  render() {
    const { wechatSrc, closeWechatDialog } = this.props.store
    return (
      <div className={style.weChatTip}>
        <div className={style.angle} />
        <div className={style.close} onClick={closeWechatDialog}>
          <img src="https://qnm.hunliji.com/Fra4HbuNUhitExikl3puQz3l-6Q9" />
        </div>
        <h3>担心错过新人咨询？绑定微信一招解决!</h3>
        <span className={style.desc}>超过15秒未回复的消息通过微信实时通知</span>
        <img src={wechatSrc} />
      </div>
    )
  }
}
